<template>
  <footer class="footer">
    <div class="container-max footer-inner">
      <div class="footer-brand">
        <h3>{{ $t('name') }}</h3>
        <p class="footer-tagline">{{ $t('footer.tagline') }}</p>
      </div>

      <div class="footer-contact">
        <a class="footer-line" href="tel:063962137">
          <span class="footer-label">{{ $t('footer.phone') }}</span>063/ 962-137
        </a>
        <a
          class="footer-line"
          href="https://www.google.com/maps/place/Mimoza+64,+Neum+88390/@42.9189757,17.6171307,17z/data=!3m1!4b1!4m6!3m5!1s0x134ba3ad1400223b:0x539ceda1ffe951f2!8m2!3d42.9189718!4d17.6197056!16s%2Fg%2F11vcvpmlhq?entry=ttu"
          target="_blank"
          rel="noopener"
        >
          <span class="footer-label">{{ $t('footer.address') }}</span>Mimoza 64, Neum BiH
        </a>
      </div>

      <div class="dropdown footer-lang dropup">
        <button class="dropdown-toggle languageButton" type="button" data-bs-toggle="dropdown" aria-expanded="false" :aria-label="$t('footer.langLabel')">
          <img src="/icons/global.svg" alt="" class="global-icons" aria-hidden="true">
          <span class="lang-current">{{ locale.toUpperCase() }}</span>
        </button>
        <ul class="dropdown-menu">
          <li><button class="dropdown-item" @click="changeLocale('en')">{{ $t('lang.en') }}</button></li>
          <li><button class="dropdown-item" @click="changeLocale('hr')">{{ $t('lang.hr') }}</button></li>
          <li><button class="dropdown-item" @click="changeLocale('de')">{{ $t('lang.de') }}</button></li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>© {{ year }} {{ $t('name') }}. {{ $t('footer.rights') }}</p>
      <p class="footer-credit">{{ $t('footer.credit') }}</p>
    </div>
  </footer>
</template>


<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'FooterComponent',
  setup() {
    const { t, locale } = useI18n();

    function changeLocale(newLocale) {
      locale.value = newLocale;
      localStorage.setItem('locale', newLocale);
    }
    return {
      t,
      locale,
      changeLocale,
      year: new Date().getFullYear()
    };
  }
};

</script>
<style scoped>
.footer {
  position: relative;
  background-color: var(--color-primary-dark);
  color: rgba(255, 255, 255, 0.85);
  padding-top: 50px;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 0 40px 40px;
}

.footer-brand h3 {
  font-family: var(--font-display);
  color: #ffffff;
  font-weight: 600;
  font-size: 24px;
  margin: 0 0 6px;
}

.footer-tagline {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 15px;
}

.footer-line {
  color: rgba(255, 255, 255, 0.85) !important;
  text-decoration: none !important;
}

.footer-line:hover {
  color: var(--color-accent-light) !important;
  text-decoration: underline !important;
}

.footer-label {
  color: rgba(255, 255, 255, 0.55);
  margin-right: 4px;
}

.footer-lang {
  display: flex;
  align-items: center;
}

.languageButton {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 30px;
  background-color: transparent;
  padding: 8px 16px;
  color: #ffffff;
  font-size: 13px;
  letter-spacing: 1px;
  transition: border-color 0.3s ease;
}

.languageButton:hover {
  border-color: var(--color-accent-light);
}

.languageButton img {
  filter: invert(1);
}

.dropup .dropdown-toggle::after {
  display: none;
}

.dropdown-item {
  font-size: 14px !important;
}

.dropdown-item:hover {
  text-decoration: underline;
}

.global-icons {
  width: 18px;
  height: 18px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 18px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footer-bottom p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.footer-credit {
  font-size: 12px !important;
  color: rgba(255, 255, 255, 0.35) !important;
}

@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
    padding: 0 24px 32px;
  }
  .footer-contact {
    align-items: center;
  }
}
</style>


